import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../../Accordion/Accordion.js";
import useSEO from "../../../hooks/useSEO.js";
import seoConfig from "../../../hooks/seoConfig.js";

import data from "../../../Data/contingentStudents/contingentStudentsData.json";

export default function ContingentStudents() {
  useSEO(seoConfig.contingentStudents);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Контингент обучающихся в ординатуре: 2018 год
      </h1>

      <Accordion data={data} />
    </section>
  );
}
